import Vue from "vue";
import App from "./App.vue";
import router from "./router/routers";
import "./router/index";
import store from "./store";
import ElementUI from "element-ui";
import Cookies from "js-cookie";
import NoData from "./components/Error/NoData";
import "./assets/styles/index.scss";
import "./assets/icons";
import "@/assets/theme/303133/index.css";
import "@/assets/theme/409EFF/index.css";
import "@/assets/theme/31C0AD/index.css";
import "@/assets/theme/FFBE40/index.css";
import "@/assets/theme/FF3A61/index.css";

Vue.config.productionTip = false;

Vue.use(ElementUI, {
  size: "small"
});

Vue.component("NoData", NoData); //加载错误

if (Cookies.get("theme")) {
  //首次进入项目时加载主题
  document.body.className = "custom-" + Cookies.get("theme");
  store.commit("setTheme", Cookies.get("theme"));
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
